export default __webpack_public_path__ + "static/media/phone-ring.56cae33c.svg";